import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { IMAGE_SRC } from '../../../shared-constants';
import { MODAL_BANNER_TYPE } from './modal-error-banner/modal-error-banner.constants';
import { BUTTON_TYPES, ButtonInfo, CONSTANTS } from './modal-frame.constants';

@Component({
  selector: 'app-modal-frame',
  templateUrl: './modal-frame.component.html',
  styleUrls: ['./modal-frame.component.scss'],
  standalone: false,
})
export class ModalFrameComponent implements OnInit {
  @Input() headerText!: string;
  @Input() hasHeaderCloseButton = true;
  @Input() rightButton: ButtonInfo = {
    text: '',
    imageSrc: '',
    type: BUTTON_TYPES.NONE,
    disable: false,
  };
  @Input() leftButton: ButtonInfo = {
    text: '',
    imageSrc: '',
    type: BUTTON_TYPES.NONE,
    disable: false,
  };
  @Input() showErrorBanner = signal(false);
  @Input() errorBannerType = signal(MODAL_BANNER_TYPE.API_ERROR);

  @Output() emitExit = new EventEmitter<string>();
  @Output() emitLeftClick = new EventEmitter<string>();
  @Output() emitRightClick = new EventEmitter<string>();

  readonly IMAGES = IMAGE_SRC;
  readonly CONSTS = CONSTANTS;
  readonly BUTTON_TYPE = BUTTON_TYPES;

  showFooter!: boolean;

  constructor(public commonUtils: CommonUtils) {}

  ngOnInit(): void {
    this.showFooter =
      this.leftButton.type !== this.BUTTON_TYPE.NONE ||
      this.rightButton.type !== this.BUTTON_TYPE.NONE;
  }

  clickExit() {
    this.emitExit.emit();
  }

  clickLeft() {
    this.emitLeftClick.emit();
  }

  clickRight() {
    this.emitRightClick.emit();
  }
}
